import { PaginatedResponse, Redirect } from '@arpeggi/shared'
import { useAuth } from '../../../__legacy__/hooks/useAuth'

export const useRedirects = () => {
  const { authenticatedGet, authenticatedDelete, authenticatedPost } = useAuth()

  const getMany = async <GetManyRedirectsParams>(params: GetManyRedirectsParams) => {
    const { data } = await authenticatedGet<PaginatedResponse<Redirect>>('/api/v2/redirects', {
      params
    })

    return data
  }

  const create = async <CreateRedirectDto extends {}>(dto: CreateRedirectDto) => {
    const { data } = await authenticatedPost<Redirect>('/api/v2/redirects', dto)

    return data
  }

  const destroy = async (id: number) => {
    await authenticatedDelete(`/api/v2/redirects/${id}`)
  }

  return { getMany, create, destroy }
}
